module.exports = "images/search.63a1bf7e.png";